import React from "react";

import SectiobImg from "../../images/recruitment01.png";

const ImageSection = () => {
  return (
    <div
      className="section-image scroll-text-animation"
      data-animation="fade_from_bottom"
    >
      <img
        src={SectiobImg}
        alt=""
        style={{ height: window.innerWidth > 990 ? "100%" : "200px" }}
      />
    </div>
  );
};

export default ImageSection;
